export default {
  label: {
    title: 'Import file',
    file: 'File',
    insertFile: 'Select file',
    link: 'Link to access the document',
    cancel: 'Cancel',
    ok: 'Ok',
    select: 'Select',
    send: 'Send',
    clear: 'Clear',
    date: 'Date of the document',
    checkbox: 'Masked',
    invalidLink: 'Invalid link',
    requiredValue: 'Required value',
  },

  infoLabel: 'Form information',
  closeLabel: 'Close information',

  upload: {
    error: 'We could not upload the document. Please check the data and try again. If the problem persists, contact support.',
    success: 'Document uploaded successfully',
    duplicated: 'This document has already been uploaded',
  },

  faq: {
    title: 'What is it?',
    description: 'Form used for importing PDF files for data reading.',
  },
  faq2: {
    title: 'How to use it?',
    description: 'Select the file on your machine in the first field. In the second field, enter the link to access the file. In the third field, select the date of the document. Finally, select if the document has masked information.',
  },
  faq3: {
    title: 'How to reset the form?',
    description: 'To clear the form, click the clear button. When an import is successful, the form resets automatically.',
  },
  faq4: {
    title: 'What happens if the import fails?',
    description: 'If an import fails, an error message will be displayed. Reset the form, check the information, and try again.',
  },
  faq5: {
    title: 'How long does it take to import a file?',
    description: 'There is a 30-second waiting time for inserting the data into the table.',
  },
  faq6: {
    title: 'Can I import more than one file?',
    description: 'The import can handle more than one file. However, if a document is divided into more than one file, it will be registered as two different documents.',
  },
};
